import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorService } from '../error/error.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { Any } from 'json2typescript';
import { EventSearchParams } from 'src/app/shared/models/events/eventSearchParams';
import { Event } from 'src/app/shared/models/events/event';
import { EventSearchResults } from 'src/app/shared/models/events/eventSearchResults';

@Injectable({
  providedIn: 'root'
})
export class EventsApiService extends ApiBaseService {

  baseUrl = environment.backend_host + '/api/events';

  constructor(
    public http: HttpClient,
    protected errorService: ErrorService,
    protected spinner: NgxSpinnerService) {
    super(spinner, errorService);
  }

  public fetchHolidays = (): Observable<Any> =>
    this.http.get<any>('https://holidayapi.com/v1/holidays', {
      params: {
        country: 'EG',
        year: String(new Date().getFullYear() - 1),
        key: '108ba780-fc7c-47d9-b2e5-544173dad32b',
      },
    }).pipe(share());

  /***********************
  // Events
  /***********************/

  public getAllEvents = (params: EventSearchParams): Observable<Event[]> => {
    const p = this.serializeParamsObj(params, new HttpParams());
    return this.http.get<any>(`${this.baseUrl}/`, { params: p })
      .pipe(map(this.deserializeArrayAs(Event)));
  }

  public createEvents = (event: Event): Observable<Event> => {
    return this.http.post<any>(`${this.baseUrl}/`, this.serialize(event))
      .pipe(map(this.deserializeAs(Event)));
  }

  public updateEvents = (event: Event): Observable<Event> => {
    return this.http.put<any>(`${this.baseUrl}/${event.id}`, this.serialize(event))
      .pipe(map(this.deserializeAs(Event)));
  }

  public deleteEvents = (eventId: Number): Observable<any> => {
    return this.http.delete<any>(`${this.baseUrl}/${eventId}`)
      .pipe(share());
  }

  public getEvent = (event: Event): Observable<Event> => {
    return this.http.get<any>(`${this.baseUrl}/${event.id}`)
      .pipe(map(this.deserializeAs(Event)));
  }

  public getEventsToday = (params: EventSearchParams): Observable<EventSearchResults> => {
    const p = this.serializeParamsObj(params, new HttpParams());
    return this.http.get<any>(`${this.baseUrl}/today`, { params: p })
      .pipe(map(this.deserializeAs(EventSearchResults)));
  }
}
